import produce from 'immer';
import { TOGGLE_TIME_FILTER_MENU } from './constants';

export const initialState = {
  timeFilterMenuStatus: false,
};

/* eslint-disable default-case, no-param-reassign */
const timeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TOGGLE_TIME_FILTER_MENU:
        draft.timeFilterMenuStatus = action.value;
        break;
      default:
        break;
    }
  });

export default timeReducer;
